import Vue from 'vue';
import EndPointNet from '@/functions/axios/axios-bearer';

Vue.prototype.$http = EndPointNet; 